import { createSlice } from "@marta/core/features/messages/slice/message-reducer";
import { MessagesState } from "./message-types";

const { reducer, actions } = createSlice<MessagesState>({
  initialState: {} as MessagesState,
});

export const messageReducer = reducer;

export const useMessageActions = () => {
  return {
    ...actions,
    //incrementBy
  };
};
